// extracted by mini-css-extract-plugin
module.exports = {"modalText":"ArchiveClientModalContent_modalText__1uFc8","modalWarn":"ArchiveClientModalContent_modalWarn__KJhyR"};